<footer class="custom-footer d-flex justify-content-between align-items-center px-4 py-3" [ngClass]="{
    'bg-dark': themeService.isDarkMode$ | async,
    'text-white': themeService.isDarkMode$ | async
  }">
  <div class="footer-left text-muted small">
    © {{ currentYear }} Insizon. All rights reserved.
  </div>
  <div class="footer-right d-flex gap-3">
    <a routerLink="/privacy-policy" class="footer-link small">Privacy</a>
    <a routerLink="/terms-of-services" class="footer-link small">Terms</a>
    <a href="mailto:support@insizon.com" class="footer-link small">Support</a>
  </div>
</footer>